// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"225":"27d833ae","276":"27d833ae","368":"a9c4934f","466":"27d833ae","484":"27d833ae","574":"27d833ae","772":"a9c4934f"}[chunkId] + ".chunk.css";
};